import React, { useState } from "react";
import { MdClose, MdOutlineCalendarToday } from "react-icons/md";
import { userRequest } from "../../utils/requestMethods";
import AlertNotification from "./AlertNotification";

const ROLE_LABELS = {
  teacher: "Teacher",
  burser: "Bursar",
  academic_admin: "Academic Admin",
};

const AddStaffModal = ({ onClose, schoolId, onStaffAdded, role, roleOptions }) => {
  const [formData, setFormData] = useState({
    email: "",
    gender: "",
    mobile_number: "",
    date_of_emp: "",
    role: role || "teacher"
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await userRequest.post(`/schools/invite/${schoolId}`, formData);
      setSuccess("Invite sent to staff member successfully!");
      setFormData({
        email: "",
        gender: "",
        mobile_number: "",
        date_of_emp: "",
        role: formData.role,
      });
      onStaffAdded();
      setTimeout(() => {
        onClose();
      }, 3000);
    } catch (error) {
      console.log(error);
      setError(error.response?.data || "An error occurred");
      setTimeout(() => {
        setError("");
      }, 5000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white rounded-3xl w-full max-w-md p-6 shadow-lg relative">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">Send Invite</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 hover:bg-gray-200 text-2xl">
            <MdClose />
          </button>
        </div>

        <p className="text-gray-600 mb-6 text-sm">
          Provide details of the {roleOptions?.length ? "admin" : (role || "staff member")} you will like to send invites to.
        </p>

        <form onSubmit={submitHandler} className="space-y-4">
          {error && (
            <AlertNotification type="error" message={error} />
          )}
          {success && (
            <AlertNotification type="success" message={success} />
          )}

          {roleOptions?.length > 0 && (
            <div>
              <label className="block text-sm text-gray-600 mb-1">Role</label>
              <select
                name="role"
                value={formData.role}
                onChange={handleChange}
                className="mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
                required
              >
                {roleOptions.map((option) => (
                  <option key={option} value={option}>
                    {ROLE_LABELS[option] || option}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div>
            <label className="block text-sm text-gray-600 mb-1">Email Address</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter email"
              className="mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
              required
            />
          </div>

          <div>
            <label className="block text-sm text-gray-600 mb-1">Gender</label>
            <select
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
              required
            >
              <option value="">Select gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          </div>

          <div>
            <label className="block text-sm text-gray-600 mb-1">Mobile Number</label>
            <input
              type="tel"
              name="mobile_number"
              value={formData.mobile_number}
              onChange={handleChange}
              placeholder="+234XXXXXXXXXX"
              className="mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
              required
            />
          </div>

          <div>
            <label className="block text-sm text-gray-600 mb-1">Date of Employment</label>
            <div className="relative">
              <input
                type="date"
                name="date_of_emp"
                value={formData.date_of_emp}
                onChange={handleChange}
                className="mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
                required
              />
            </div>
          </div>

          <div className="mt-4">
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#3F3DA5] text-white font-semibold rounded-full p-2 hover:bg-indigo-800 transition disabled:opacity-50"
            >
              {loading ? "Submitting..." : "Proceed"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddStaffModal; 